import { taskAxiosInstance } from "../axiosInstance";
import type { Task } from "./taskApi";

export interface TaskGroup {
    id: number;
    instanceId: number;
    title: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
    createdById: number;
    updatedById: number;
}

export interface TaskGroupWithTasks extends TaskGroup {
    tasks: Task[];
}

export interface CreateTaskGroupInput {
    instanceId: number;
    title: string;
}

export interface UpdateTaskGroupInput {
    title?: string;
}

export interface TaskGroupQuery {
    instanceId?: number;
}

export const getTaskGroups = async (query: TaskGroupQuery = {}): Promise<TaskGroup[]> => {
    const params = new URLSearchParams();
    if (query.instanceId !== undefined) params.set("instanceId", query.instanceId.toString());

    const queryString = params.toString();
    const response = (
        await taskAxiosInstance.get<TaskGroup[]>(
            `/task-groups${queryString ? `?${queryString}` : ""}`,
        )
    ).data;
    return response;
};

export const getTaskGroupById = async (id: number): Promise<TaskGroup> => {
    const response = (await taskAxiosInstance.get<TaskGroup>(`/task-groups/${id}`)).data;
    return response;
};

export const createTaskGroup = async (data: CreateTaskGroupInput): Promise<TaskGroup> => {
    const response = (await taskAxiosInstance.post<TaskGroup>("/task-groups", data)).data;
    return response;
};

export const updateTaskGroup = async (
    id: number,
    data: UpdateTaskGroupInput,
): Promise<TaskGroup> => {
    const response = (await taskAxiosInstance.patch<TaskGroup>(`/task-groups/${id}`, data)).data;
    return response;
};

export const deleteTaskGroup = async (id: number): Promise<TaskGroup> => {
    const response = (await taskAxiosInstance.post<TaskGroup>(`/task-groups/${id}/delete`)).data;
    return response;
};
